@if (itemOption.bundle.length > 0) {
  <eas-editor-booking-item-bundle-summary [bundle]="itemOption.bundle">
  </eas-editor-booking-item-bundle-summary>
  <br>
  }
  @for (itemSetting of itemOption.getSettingsWithSummary(); track itemSetting; let itemSettingFirst = $first; let itemSettingLast = $last) {
    @switch (itemSetting.settingClassName) {
      @case ('BookingDate') {
        <eas-editor-booking-item-setting-summary-booking-date [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
        </eas-editor-booking-item-setting-summary-booking-date>
      }
      @case ('BookingWindow') {
        <eas-editor-booking-item-setting-summary-booking-window [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
        </eas-editor-booking-item-setting-summary-booking-window>
      }
      @case ('Capacity') {
        <eas-editor-booking-item-setting-summary-capacity [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
        </eas-editor-booking-item-setting-summary-capacity>
      }
      @case ('Eligibility') {
        <eas-editor-booking-item-setting-summary-eligibility [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
        </eas-editor-booking-item-setting-summary-eligibility>
      }
      @case ('Pricing') {
        <eas-editor-booking-item-setting-summary-pricing [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
        </eas-editor-booking-item-setting-summary-pricing>
      }
      @case ('Venue') {
        <eas-editor-booking-item-setting-summary-venue [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
        </eas-editor-booking-item-setting-summary-venue>
      }
      @case ('Workflow') {
        <eas-editor-booking-item-setting-summary-workflow [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
        </eas-editor-booking-item-setting-summary-workflow>
      }
    }
  }
